export const BIG_MENU_MIN_COUNT = 5;
